import { MutationType, ResourceType } from '@tencent/slide-sdk-pb-model';
import { shallowOmit } from '../utils/object-utils';
import { DEFAULT_KEYFRAME_CONTEXT, type KeyframeContext } from './keyframe-context.interface';
import type { IValidUpdateResourceMapMutationData } from '../mutation/base';
import type { IResourceMapData } from '../data/resource-map-data';

export function getResourceMapKeyframe(
    resourceMap: IResourceMapData,
    context: KeyframeContext = DEFAULT_KEYFRAME_CONTEXT,
) {
    const mutations: IValidUpdateResourceMapMutationData[] = [];
    for (const [id, imageResource] of Object.entries(resourceMap.images)) {
        mutations.push({
            type: MutationType.UpdateResourceMap,
            id: context.idFactory(id),
            resourceType: ResourceType.Image,
            imageDescriptor: shallowOmit(imageResource, 'id'),
        });
    }

    for (const [id, videoResource] of Object.entries(resourceMap.videos)) {
        mutations.push({
            type: MutationType.UpdateResourceMap,
            id: context.idFactory(id),
            resourceType: ResourceType.Video,
            videoDescriptor: shallowOmit(videoResource, 'id'),
        });
    }

    for (const [id, audioResource] of Object.entries(resourceMap.audios)) {
        mutations.push({
            type: MutationType.UpdateResourceMap,
            id: context.idFactory(id),
            resourceType: ResourceType.Audio,
            audioDescriptor: shallowOmit(audioResource, 'id'),
        });
    }

    for (const [id, fontResource] of Object.entries(resourceMap.fonts)) {
        mutations.push({
            type: MutationType.UpdateResourceMap,
            id: context.idFactory(id),
            resourceType: ResourceType.Font,
            fontDescriptor: shallowOmit(fontResource, 'id'),
        });
    }

    return mutations;
}
